export default "__VITE_ASSET__C_ItT350__"